import CmsCookieConsent from '../CmsComponents/components/CmsCookieConsent/CmsCookieConsent';
import styles from '@components/components/NoConsentWidget/NoConsentWidget.module.scss';
import React from 'react';
import { Content } from '@wienenergiegithub/ui-next';
import { FontAwesomeProIcon } from '@ui/components';

const NoConsentWidget = () => (
  <div className={styles.container}>
    <div className={styles.infoContainer}>
      <div className={styles.infoHighlighted}>
        <FontAwesomeProIcon
          icon="circle-info"
          role="presentation"
          type="regular"
        />
        <Content className={styles.highlightedText} noSpacing>
          Wir benötigen Ihre Zustimmung
        </Content>
      </div>
      <Content className={styles.regularText} noSpacing>
        Dieser Inhalt wurde aufgrund Ihrer Datenschutzeinstellungen deaktiviert.
        Bitte ändern Sie Ihre Einstellungen, um die Inhalte sehen zu können.
      </Content>
    </div>
    <CmsCookieConsent
      className={styles.consentButton}
      isAnimated={false}
      text="Einstellungen ändern"
      variant="link"
    />
  </div>
);

export default NoConsentWidget;
